import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { AlumnosSection } from '../components/AlumnosSection';
import { CourseContentSection } from '../components/CourseContentSection';
import { TestimonialsBanner } from '../components/TestimonialsBanner';
import { TestimonialsFeatures } from '../components/TestimonialsFeatures';
import { BonusSection } from '../components/BonusSection';
import { FAQ2Section } from '../components/FAQ2Section';
import { TestimonialsMasonrySection } from '../components/TestimonialsMasonrySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-brand-bg" data-id="element-283">
      <HeroSection data-id="element-284" />
      <CaseStudySection data-id="element-285" />
      <PricingSection data-id="element-286" />

      <AlumnosSection data-id="element-287" />
      <CourseContentSection data-id="element-288" />
      <TestimonialsBanner data-id="element-289" />
      <TestimonialsFeatures data-id="element-290" />
      <BonusSection data-id="element-291" />
      <TestimonialsSection data-id="element-292" />
      <TestimonialsMasonrySection data-id="element-293" />
      <FAQ2Section data-id="element-294" />
      <FinalCTASection data-id="element-295" />
    </main>;
}